// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://onidtqmmhjazpbalzclp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9uaWR0cW1taGphenBiYWx6Y2xwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1MzQ2MDgsImV4cCI6MjA2MDExMDYwOH0.Oa3f8hsjav1y3in_EItRs9rZqqsRuJ-nc5TdwNdCIIo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);